(function() {
  "use strict";
  window.__dimaBundleV = 2;

  // Kill any old inline bundle script's intervals/timeouts
  (function() {
    var scripts = document.querySelectorAll("script:not([src])");
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].textContent.length > 10000 && scripts[i].textContent.indexOf("dima-bundle-root") !== -1 && scripts[i].textContent.indexOf("__dimaBundleV") === -1) {
        scripts[i].parentNode.removeChild(scripts[i]);
      }
    }
    // Clear all intervals that the old script may have set up
    var id = setInterval(function(){}, 9999);
    for (var j = id - 200; j <= id; j++) { if (j > 0) clearInterval(j); }
    clearInterval(id);
  })();

  var STYLE = document.createElement("style");
  STYLE.textContent = "#dima-bundle-root{--navy:#0A1628;--blue:#2563EB;--blue-dark:#1D4ED8;--blue-light:#DBEAFE;--blue-lighter:#EFF6FF;--bg:#FAFAF8;--muted:#6B7280;--border:#E5E7EB;--green:#16A34A;--green-light:#DCFCE7;font-family:\"DM Sans\",sans-serif;background:var(--bg);color:var(--navy);line-height:1.5;max-width:480px;margin:0 auto;padding:0 16px 20px;-webkit-font-smoothing:antialiased}#dima-bundle-root *{box-sizing:border-box;margin:0;padding:0}#dima-bundle-root .db-header{text-align:center;padding:20px 0 16px;border-bottom:1px solid var(--border);margin-bottom:24px;position:relative}#dima-bundle-root .db-retake{position:absolute;left:0;top:50%;transform:translateY(-50%);font-size:13px;color:var(--blue);text-decoration:none;font-weight:600;cursor:pointer}#dima-bundle-root .db-retake:hover{text-decoration:underline}#dima-bundle-root .db-header-logo{font-family:\"Playfair Display\",serif;font-size:22px;font-weight:900;letter-spacing:-0.02em;color:var(--navy)}#dima-bundle-root .db-intro{text-align:center;margin-bottom:20px}#dima-bundle-root .db-checkmark{width:48px;height:48px;background:var(--blue-lighter);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 12px;color:var(--blue);font-size:22px;font-weight:700}#dima-bundle-root .db-intro h1{font-family:\"Playfair Display\",serif;font-size:24px;font-weight:700;letter-spacing:-0.02em;margin-bottom:6px}#dima-bundle-root .db-intro p{font-size:14px;color:var(--muted);line-height:1.6}#dima-bundle-root .db-trust-bar{display:flex;justify-content:space-evenly;margin-bottom:24px;padding:12px 0}#dima-bundle-root .db-trust-item{display:flex;flex-direction:column;align-items:center;flex:1;text-align:center}#dima-bundle-root .db-trust-label{margin-top:6px}#dima-bundle-root .db-trust-icon{width:28px;height:28px;background:var(--blue-lighter);border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0}#dima-bundle-root .db-trust-icon svg{width:14px;height:14px;color:var(--blue)}#dima-bundle-root .db-trust-label{font-size:11px;color:var(--navy);font-weight:600;letter-spacing:0.01em}#dima-bundle-root .db-section-label{font-size:12px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:var(--muted);margin-bottom:10px}#dima-bundle-root .db-product-toggles{display:flex;flex-direction:column;margin-bottom:8px}#dima-bundle-root .db-product-toggle+.db-product-toggle{margin-top:10px}#dima-bundle-root .db-product-toggle{border:2px solid var(--border);background:white;padding:14px 16px;cursor:pointer;transition:border-color .15s,background .15s;position:relative}#dima-bundle-root .db-product-toggle:hover{border-color:var(--blue-light)}#dima-bundle-root .db-product-toggle.active{border-color:var(--blue);background:var(--blue-lighter)}#dima-bundle-root .db-product-toggle-top{display:flex;align-items:center}#dima-bundle-root .db-product-img{margin-left:12px}#dima-bundle-root .db-product-info{margin-left:12px}#dima-bundle-root .db-check{width:22px;height:22px;border:2px solid var(--border);display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .15s;color:white;font-size:13px}#dima-bundle-root .db-product-toggle.active .db-check{background:var(--blue);border-color:var(--blue)}#dima-bundle-root .db-product-img{width:48px;height:48px;border:1px solid var(--border);object-fit:cover;background:white}#dima-bundle-root .db-product-info h3{font-family:\"Playfair Display\",serif;font-size:15px;font-weight:700;letter-spacing:-0.01em}#dima-bundle-root .db-product-info .db-subtitle{font-size:12px;color:var(--muted)}#dima-bundle-root .db-product-price{margin-left:auto;text-align:right;flex-shrink:0}#dima-bundle-root .db-product-price .db-from{font-size:11px;color:var(--muted)}#dima-bundle-root .db-product-price .db-amount{font-size:15px;font-weight:700}#dima-bundle-root .db-approved-badge{position:absolute;top:-10px;right:12px;background:var(--green);color:white;font-size:10px;font-weight:700;padding:2px 10px;letter-spacing:0.06em;text-transform:uppercase}#dima-bundle-root .db-bundle-nudge{margin-top:4px;margin-bottom:20px;padding:12px 14px;border:1px dashed var(--blue-light);background:var(--blue-lighter);display:flex;align-items:center;font-size:13px;color:var(--navy);cursor:pointer;transition:background .15s}#dima-bundle-root .db-bundle-nudge:hover{background:var(--blue-light)}#dima-bundle-root .db-nudge-icon{width:28px;height:28px;background:var(--blue-light);border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-right:10px}#dima-bundle-root .db-nudge-icon svg{width:14px;height:14px;color:var(--blue)}#dima-bundle-root .db-bundle-nudge strong{color:var(--blue)}#dima-bundle-root .db-free-ship{color:var(--green);font-weight:700}#dima-bundle-root .db-nudge-cta{margin-left:auto;font-weight:700;color:var(--blue);white-space:nowrap;font-size:13px}#dima-bundle-root .db-bundle-unlocked{margin-top:4px;margin-bottom:20px;padding:12px 14px;background:var(--green-light);border:1px solid #BBF7D0;display:flex;align-items:center;font-size:13px;color:var(--navy)}#dima-bundle-root .db-unlocked-icon{width:28px;height:28px;background:#BBF7D0;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-right:10px}#dima-bundle-root .db-unlocked-icon svg{width:14px;height:14px;color:var(--green)}#dima-bundle-root .db-bundle-unlocked strong{color:var(--green)}#dima-bundle-root .db-supply-section{margin-bottom:24px}#dima-bundle-root .db-supply-header{display:flex;align-items:center;margin-bottom:12px}#dima-bundle-root .db-supply-header>div{margin-left:10px}#dima-bundle-root .db-supply-header img{width:36px;height:36px;border:1px solid var(--border);object-fit:cover;background:white}#dima-bundle-root .db-supply-header h3{font-size:14px;font-weight:700}#dima-bundle-root .db-supply-header .db-subtitle{font-size:12px;color:var(--muted)}#dima-bundle-root .db-tier-cards{display:flex;flex-direction:column}#dima-bundle-root .db-tier-card+.db-tier-card{margin-top:8px}#dima-bundle-root .db-tier-card{border:2px solid var(--border);background:white;padding:12px 14px;cursor:pointer;position:relative;transition:border-color .15s,background .15s}#dima-bundle-root .db-tier-card:hover{border-color:var(--blue-light);background:var(--blue-lighter)}#dima-bundle-root .db-tier-card.selected{border-color:var(--blue);background:var(--blue-lighter)}#dima-bundle-root .db-tier-card.best-value,#dima-bundle-root .db-tier-card.recommended{border-color:var(--border)}#dima-bundle-root .db-tier-badge{position:absolute;top:-10px;right:12px;background:var(--blue);color:#fff;font-size:10px;font-weight:700;padding:2px 10px;letter-spacing:0.06em;text-transform:uppercase}#dima-bundle-root .db-tier-top{display:flex;justify-content:space-between;align-items:center}#dima-bundle-root .db-tier-top-left{display:flex;align-items:center}#dima-bundle-root .db-tier-top-left>div{margin-left:10px}#dima-bundle-root .db-tier-radio{width:18px;height:18px;border:2px solid var(--border);border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:border-color .15s}#dima-bundle-root .db-tier-card.selected .db-tier-radio{border-color:var(--blue);background:var(--blue);box-shadow:inset 0 0 0 3px #fff}#dima-bundle-root .db-tier-label{font-size:14px;font-weight:600}#dima-bundle-root .db-tier-sublabel{font-size:11px;color:var(--muted)}#dima-bundle-root .db-tier-right{text-align:right;display:flex;flex-direction:column;align-items:flex-end}#dima-bundle-root .db-tier-total{margin-top:1px}#dima-bundle-root .db-tier-per-day{font-size:17px;font-weight:700;color:var(--navy);line-height:1.1}#dima-bundle-root .db-tier-per-day-unit{font-size:12px;font-weight:500;color:var(--muted)}#dima-bundle-root .db-tier-total{font-size:11px;color:var(--muted)}#dima-bundle-root .db-tier-total .db-original{text-decoration:line-through;margin-right:3px}#dima-bundle-root .db-discount-tag{display:inline-block;font-size:10px;font-weight:700;color:var(--green);background:var(--green-light);padding:1px 6px;letter-spacing:0.02em}#dima-bundle-root .db-divider{height:1px;background:var(--border);margin:20px 0}#dima-bundle-root .db-order-summary{background:white;border:1px solid var(--border);padding:16px;margin-bottom:12px}#dima-bundle-root .db-order-summary h3{font-family:\"Playfair Display\",serif;font-size:15px;font-weight:700;margin:0 0 12px;letter-spacing:-0.01em}#dima-bundle-root .db-summary-row{display:flex;justify-content:space-between;font-size:14px;margin-bottom:6px}#dima-bundle-root .db-summary-row.db-total{font-weight:700;font-size:16px;border-top:1px solid var(--border);padding-top:10px;margin-top:8px;margin-bottom:0}#dima-bundle-root .db-summary-row.db-per-day-row{font-size:13px;color:var(--blue);font-weight:600;margin-top:6px}#dima-bundle-root .db-savings{color:var(--green);font-weight:600}#dima-bundle-root .db-shipping-bar{margin-bottom:20px}#dima-bundle-root .db-shipping-text{font-size:13px;text-align:center;margin-bottom:6px}#dima-bundle-root .db-shipping-text strong{color:var(--green)}#dima-bundle-root .db-shipping-track{height:5px;background:var(--border);overflow:hidden}#dima-bundle-root .db-shipping-fill{height:100%;background:var(--green);transition:width .3s}#dima-bundle-root .db-urgency{background:var(--blue-lighter);border:1px solid var(--blue-light);border-left:3px solid var(--blue);padding:14px 16px;margin-bottom:16px}#dima-bundle-root .db-urgency-headline{font-family:\"Playfair Display\",serif;font-size:15px;font-weight:700;color:var(--blue-dark);margin-bottom:4px}#dima-bundle-root .db-urgency-body{font-size:13px;line-height:1.5;color:var(--navy)}#dima-bundle-root .db-urgency-body strong{color:var(--blue)}#dima-bundle-root .db-checkout-sticky{background:white;padding:12px 16px;border-top:1px solid var(--border);margin-top:20px}#dima-bundle-root .db-checkout-inner{max-width:480px;margin:0 auto}#dima-bundle-root .db-checkout-btn{width:100%;padding:16px;background:#2563EB;border:none;font-family:\"DM Sans\",sans-serif;font-size:16px;font-weight:700;cursor:pointer;transition:background .15s;color:white;letter-spacing:0.02em}#dima-bundle-root .db-checkout-btn:hover{background:#1D4ED8}#dima-bundle-root .db-checkout-btn:active{transform:scale(0.98)}#dima-bundle-root .db-checkout-btn:disabled{opacity:0.4;cursor:not-allowed}#dima-bundle-root .db-ineligible{text-align:center;padding:40px 20px}#dima-bundle-root .db-ineligible .db-icon{font-size:48px;margin-bottom:16px}#dima-bundle-root .db-ineligible h1{font-family:\"Playfair Display\",serif;font-size:20px;margin:0 0 12px}#dima-bundle-root .db-ineligible p{font-size:14px;color:var(--muted);margin-bottom:24px;line-height:1.6}#dima-bundle-root .db-ineligible a{color:var(--blue);font-weight:600;text-decoration:none}#dima-bundle-root .db-empty-state{text-align:center;padding:24px 16px;color:var(--muted);font-size:14px}";
  document.head.appendChild(STYLE);

  if (!document.querySelector("link[href*=Playfair]")) {
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Playfair+Display:wght@700;900&display=swap";
    document.head.appendChild(link);
  }

  var PRODUCTS = {
    finasteride: {
      name: "Finasteride 1mg",
      subtitle: "30 tablets · once daily",
      tagline: "Blocks DHT — the #1 cause of hair loss",
      img: "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/Finasteride_Dima_1_feaa55bd-2f0f-4494-a242-144c9bc6bcf3.png?v=1713242045",
      variantId: 50864654352665
    },
    minoxidil: {
      name: "Oral Minoxidil 2.5mg",
      subtitle: "30 capsules · once daily",
      tagline: "Boosts blood flow to regrow thicker hair",
      img: "https://cdn.shopify.com/s/files/1/0757/9913/4489/files/Website_Product_Image_Template_5.png?v=1749621816",
      variantId: 50899502989593
    }
  };

  var TIERS_FINASTERIDE = [
    { months: 1, boxes: 1, fullPrice: 1500, discount: 0, price: 1500 },
    { months: 3, boxes: 3, fullPrice: 4500, discount: 0.10, price: 4050 },
    { months: 6, boxes: 6, fullPrice: 9000, discount: 0.15, price: 7650 }
  ];

  var TIERS_MINOXIDIL = [
    { months: 1, boxes: 1, fullPrice: 1500, discount: 0, price: 1500 },
    { months: 3, boxes: 3, fullPrice: 4500, discount: 0, price: 4500 }
  ];

  function getTiers(productKey) {
    return productKey === "minoxidil" ? TIERS_MINOXIDIL : TIERS_FINASTERIDE;
  }

  var FREE_SHIPPING_THRESHOLD = 2500;
  var SHIPPING_COST = 100;

  function getQuizData() {
    var sex = "male";
    var pregnant = false;
    var rec = "both";
    try {
      var answers = (typeof Quiz !== "undefined" && Quiz.answers) ? Quiz.answers : ((typeof quiz !== "undefined" && quiz.answers) ? quiz.answers : []);
      for (var i = 0; i < answers.length; i++) {
        var a = answers[i];
        if (a.choicesRefs && a.choicesRefs.indexOf("qbcc-463ea156") !== -1) { sex = "male"; }
        else if (a.choicesRefs && a.choicesRefs.indexOf("qbcc-bd6ffa26") !== -1) { sex = "female"; }
        else if (a.value === "Male") { sex = "male"; }
        else if (a.value === "Female") { sex = "female"; }
        if (a.choicesRefs && a.choicesRefs.indexOf("qbcc-8d5ef485") !== -1) { pregnant = true; }
        else if (a.choicesRefs && a.choicesRefs.indexOf("qbcc-a094999c") !== -1) { pregnant = true; }
        else if (a.value === "Pregnant" || a.value === "Breastfeeding") { pregnant = true; }
      }
    } catch(e) { console.warn("[DIMA Bundle] Could not read quiz answers:", e); }
    if (sex === "female") { rec = "minoxidil"; } else { rec = "both"; }
    return { sex: sex, pregnant: pregnant, rec: rec };
  }

  var quizData = { sex: "male", pregnant: false, rec: "both" };
  var state = { selected: {}, tiers: {} };

  function getAvailableProducts() {
    if (quizData.sex === "female") return ["minoxidil"];
    return ["finasteride", "minoxidil"];
  }

  function getSelectedProducts() {
    return Object.keys(state.selected).filter(function(k) { return state.selected[k]; });
  }

  function perDay(price, months) { return Math.round(price / (months * 30)); }

  function injectRoot() {
    var all = document.querySelectorAll("#dima-bundle-root");
    for (var i = 1; i < all.length; i++) { all[i].parentNode.removeChild(all[i]); }
    var root = all[0] || null;
    if (!root) {
      root = document.createElement("div");
      root.id = "dima-bundle-root";
      var mc = document.getElementById("MainContent") || document.querySelector("main");
      if (mc) { mc.appendChild(root); } else { document.body.appendChild(root); }
    }
    return root;
  }

  function renderTrustBar() {
    var shield = "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z\"/></svg>";
    var clock = "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><polyline points=\"12 6 12 12 16 14\"/></svg>";
    var box = "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"2\" y=\"7\" width=\"20\" height=\"14\" rx=\"2\"/><path d=\"M16 7V5a4 4 0 00-8 0v2\"/></svg>";
    function item(svg, label) {
      return "<div class=\"db-trust-item\"><div class=\"db-trust-icon\">" + svg + "</div><div class=\"db-trust-label\">" + label + "</div></div>";
    }
    var shieldLabel = quizData.sex === "female" ? "Compounded in<br>FDA-approved pharmacy" : "FDA-approved";
    return "<div class=\"db-trust-bar\">" + item(shield, shieldLabel) + item(clock, "Results in as little as<br>3 months*") + item(box, "Discreet delivery") + "</div>";
  }

  function renderProductToggles() {
    var available = getAvailableProducts();
    var html = "<div class=\"db-section-label\">Select your treatments</div><div class=\"db-product-toggles\">";
    available.forEach(function(key) {
      var p = PRODUCTS[key];
      var isActive = state.selected[key];
      var selectedTier = state.tiers[key] || 3;
      var tiers = getTiers(key);
      var tierData = tiers.filter(function(t) { return t.months === selectedTier; })[0];
      var daily = perDay(tierData.price, tierData.months);
      html += "<div class=\"db-product-toggle " + (isActive ? "active" : "") + "\" data-toggle=\"" + key + "\">" +
        "<div class=\"db-approved-badge\">Approved for you</div>" +
        "<div class=\"db-product-toggle-top\">" +
          "<div class=\"db-check\">" + (isActive ? "✓" : "") + "</div>" +
          "<img class=\"db-product-img\" src=\"" + p.img + "\" alt=\"" + p.name + "\">" +
          "<div class=\"db-product-info\"><h3>" + p.name + "</h3><div class=\"db-subtitle\">" + p.tagline + "</div></div>" +
          "<div class=\"db-product-price\"><div class=\"db-from\">from</div><div class=\"db-amount\">₱" + daily + "<span class=\"db-tier-per-day-unit\">/day</span></div></div>" +
        "</div></div>";
    });
    html += "</div>";
    return html;
  }

  function renderBundleBanner() {
    var available = getAvailableProducts();
    var selected = getSelectedProducts();
    if (available.length !== 2) return "";
    var checkSvg = "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 12l2 2 4-4\"/><path d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z\"/></svg>";
    var plusSvg = "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><line x1=\"12\" y1=\"5\" x2=\"12\" y2=\"19\"/><line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"/></svg>";
    if (selected.length === 2) {
      return "<div class=\"db-bundle-unlocked\"><div class=\"db-unlocked-icon\">" + checkSvg + "</div><div><strong>Dual-action bundle!</strong> Combining both is clinically proven to deliver the best results. <strong style=\"color:#16A34A\">Free shipping if you bundle both!</strong></div></div>";
    }
    if (selected.length === 1) {
      var missing = available.filter(function(k) { return !state.selected[k]; })[0];
      var mp = PRODUCTS[missing];
      return "<div class=\"db-bundle-nudge\" data-toggle=\"" + missing + "\"><div class=\"db-nudge-icon\">" + plusSvg + "</div><div>Add <strong>" + mp.name + "</strong> for the dual-action combo + <span class=\"db-free-ship\">free shipping</span></div><div class=\"db-nudge-cta\">+ Add</div></div>";
    }
    return "";
  }

  function renderSupplySection(productKey) {
    var product = PRODUCTS[productKey];
    var tiers = getTiers(productKey);
    var selectedMonths = state.tiers[productKey] || 3;
    var html = "<div class=\"db-supply-section\"><div class=\"db-supply-header\"><img src=\"" + product.img + "\" alt=\"" + product.name + "\"><div><h3>" + product.name + "</h3><div class=\"db-subtitle\">" + product.subtitle + "</div></div></div><div class=\"db-tier-cards\">";
    tiers.forEach(function(tier) {
      var isSelected = selectedMonths === tier.months;
      var classes = "db-tier-card";
      if (isSelected) classes += " selected";
      if (tier.months === 6) classes += " best-value";
      if (tier.months === 3 && productKey !== "minoxidil") classes += " recommended";
      var daily = perDay(tier.price, tier.months);
      var badge = "";
      if (tier.months === 6) badge = "<div class=\"db-tier-badge\">Best value</div>";
      else if (tier.months === 3 && productKey !== "minoxidil") badge = "<div class=\"db-tier-badge\">Recommended</div>";
      var radioOuterStyle = isSelected ? "border-color:#2563EB;background:#2563EB;box-shadow:inset 0 0 0 3px #fff" : "";
      html += "<div class=\"" + classes + "\" data-product=\"" + productKey + "\" data-months=\"" + tier.months + "\">" + badge +
        "<div class=\"db-tier-top\"><div class=\"db-tier-top-left\"><div class=\"db-tier-radio\" style=\"" + radioOuterStyle + "\"></div><div><div class=\"db-tier-label\">" + tier.months + " month" + (tier.months > 1 ? "s" : "") + "</div><div class=\"db-tier-sublabel\">" + tier.boxes + " box" + (tier.boxes > 1 ? "es" : "") + "</div></div></div>" +
        "<div class=\"db-tier-right\"><div class=\"db-tier-per-day\">₱" + daily + "<span class=\"db-tier-per-day-unit\">/day</span></div><div class=\"db-tier-total\">" + (tier.discount > 0 ? "<span class=\"db-original\">₱" + tier.fullPrice.toLocaleString() + "</span>" : "") + "₱" + tier.price.toLocaleString() + "</div>" + (tier.discount > 0 ? "<div class=\"db-discount-tag\">Save " + (tier.discount * 100) + "%</div>" : "") + "</div></div></div>";
    });
    html += "</div></div>";
    return html;
  }

  function calculateTotals() {
    var subtotal = 0, fullPriceTotal = 0, items = [], combinedPerDay = 0;
    getSelectedProducts().forEach(function(key) {
      var months = state.tiers[key] || 3;
      var tiers = getTiers(key);
      var tier = tiers.filter(function(t) { return t.months === months; })[0];
      subtotal += tier.price;
      fullPriceTotal += tier.fullPrice;
      combinedPerDay += perDay(tier.price, months);
      items.push({ name: PRODUCTS[key].name, months: months, price: tier.price });
    });
    var supplyDiscount = fullPriceTotal - subtotal;
    var qualifiesFreeShipping = subtotal >= FREE_SHIPPING_THRESHOLD;
    var shippingSaved = qualifiesFreeShipping ? SHIPPING_COST : 0;
    var shipping = qualifiesFreeShipping ? 0 : SHIPPING_COST;
    return { subtotal: subtotal, fullPriceTotal: fullPriceTotal, supplyDiscount: supplyDiscount, qualifiesFreeShipping: qualifiesFreeShipping, totalSaved: supplyDiscount + shippingSaved, shipping: shipping, total: subtotal + shipping, items: items, combinedPerDay: combinedPerDay };
  }

  function renderShippingBar() {
    var calc = calculateTotals();
    var selected = getSelectedProducts();
    var available = getAvailableProducts();
    var progress = Math.min(calc.subtotal / FREE_SHIPPING_THRESHOLD * 100, 100);
    var text;
    if (calc.qualifiesFreeShipping) { text = "<strong>You qualify for free shipping!</strong>"; }
    else if (available.length === 2 && selected.length < 2) { text = "<strong>Bundle both medications for free shipping</strong>"; }
    else if (available.length === 1) { text = "<strong>Order a 3-month supply for free shipping</strong>"; }
    else { text = "Add <strong>₱" + Math.max(FREE_SHIPPING_THRESHOLD - calc.subtotal, 0).toLocaleString() + "</strong> more for free shipping"; }
    return "<div class=\"db-shipping-bar\"><div class=\"db-shipping-text\">" + text + "</div><div class=\"db-shipping-track\"><div class=\"db-shipping-fill\" style=\"width:" + progress + "%\"></div></div></div>";
  }

  function renderOrderSummary() {
    var calc = calculateTotals();
    var html = "<div class=\"db-order-summary\"><h3>Order Summary</h3>";
    calc.items.forEach(function(item) {
      html += "<div class=\"db-summary-row\"><span>" + item.name + " · " + item.months + "mo</span><span>₱" + item.price.toLocaleString() + "</span></div>";
    });
    html += "<div class=\"db-summary-row\"><span>Shipping</span><span>" + (calc.qualifiesFreeShipping ? "<strong style=\"color:#16A34A\">FREE</strong>" : "₱" + calc.shipping) + "</span></div>";
    if (calc.totalSaved > 0) { html += "<div class=\"db-summary-row db-savings\"><span>You save</span><span>−₱" + calc.totalSaved.toLocaleString() + "</span></div>"; }
    html += "<div class=\"db-summary-row db-total\"><span>Total</span><span>₱" + calc.total.toLocaleString() + "</span></div>";
    html += "<div class=\"db-summary-row db-per-day-row\"><span>That’s only</span><span>₱" + calc.combinedPerDay + "/day for your treatment</span></div></div>";
    return html;
  }

  function renderUrgencyBanner() {
    var stat = quizData.sex === "female" ? "98% of women" : "95% of men";
    return "<div class=\"db-urgency\"><div class=\"db-urgency-headline\">" + stat + " wish they started sooner.</div><div class=\"db-urgency-body\"><strong>Don’t wait!</strong> Hair lost today is harder to recover tomorrow.</div></div>";
  }

  function renderCheckoutButton() {
    var selected = getSelectedProducts();
    if (selected.length === 0) {
      return "<div class=\"db-checkout-sticky\"><div class=\"db-checkout-inner\"><button class=\"db-checkout-btn\" disabled>Select a treatment to continue</button></div></div>";
    }
    var calc = calculateTotals();
    return "<div class=\"db-checkout-sticky\"><div class=\"db-checkout-inner\"><button class=\"db-checkout-btn\" id=\"db-checkout-btn\">Continue to Checkout · ₱" + calc.total.toLocaleString() + "</button></div></div>";
  }

  function renderIneligible() {
    return "<div class=\"db-ineligible\"><div class=\"db-icon\">💙</div><h1>We Care About Your Safety</h1><p>Based on your answers, our hair treatments aren’t recommended during pregnancy or breastfeeding. Please consult your doctor for safe alternatives.</p><a href=\"/\">Return to DIMA</a></div>";
  }

  function render() {
    var root = injectRoot();
    if (!root) return;
    if (quizData.sex === "female" && quizData.pregnant) {
      root.innerHTML = "<div class=\"db-header\"><div class=\"db-header-logo\">DIMA</div></div>" + renderIneligible();
      return;
    }
    var selected = getSelectedProducts();
    var hasSelection = selected.length > 0;
    var html = "<div class=\"db-header\"><div class=\"db-header-logo\">DIMA</div><a href=\"#\" id=\"db-retake-btn\" class=\"db-retake\">Retake Quiz</a></div>" +
      "<div class=\"db-intro\"><div class=\"db-checkmark\">✓</div><h1>Your Treatment Plan</h1><p>Based on your assessment, here’s what our doctors recommend.</p></div>";
    html += renderTrustBar();
    html += renderProductToggles();
    html += renderBundleBanner();
    if (hasSelection) {
      html += "<div class=\"db-section-label\">Choose your supply</div>";
      selected.forEach(function(key) { html += renderSupplySection(key); });
    } else {
      html += "<div class=\"db-empty-state\">Select at least one treatment above to continue.</div>";
    }
    if (hasSelection) {
      html += "<div class=\"db-divider\"></div>";
      html += renderShippingBar();
      html += renderOrderSummary();
      html += renderUrgencyBanner();
    }
    html += renderCheckoutButton();
    html += "<span id=\"dima-v2-mark\" style=\"display:none\"></span>";
    root.innerHTML = html;
    attachListeners();
  }

  function attachListeners() {
    var toggles = document.querySelectorAll("#dima-bundle-root [data-toggle]");
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener("click", function() {
        var key = this.getAttribute("data-toggle");
        state.selected[key] = !state.selected[key];
        if (getSelectedProducts().length === 0) { state.selected[key] = true; return; }
        render();
      });
    }
    var tierCards = document.querySelectorAll("#dima-bundle-root .db-tier-card");
    for (var j = 0; j < tierCards.length; j++) {
      tierCards[j].addEventListener("click", function() {
        state.tiers[this.getAttribute("data-product")] = parseInt(this.getAttribute("data-months"));
        render();
      });
    }
    var retake = document.getElementById("db-retake-btn");
    if (retake) {
      retake.addEventListener("click", function(e) {
        e.preventDefault();
        Object.keys(localStorage).forEach(function(k) {
          if (k.indexOf("revenuehunt") > -1 || k.indexOf("quiz") > -1 || k.indexOf("prq") > -1 || k.indexOf("rh-") > -1) localStorage.removeItem(k);
        });
        Object.keys(sessionStorage).forEach(function(k) {
          if (k.indexOf("revenuehunt") > -1 || k.indexOf("quiz") > -1 || k.indexOf("prq") > -1 || k.indexOf("rh-") > -1) sessionStorage.removeItem(k);
        });
        document.cookie.split(";").forEach(function(c) {
          var name = c.split("=")[0].trim();
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        });
        try {
          var answers = quiz.answers || [];
          for (var i = 0; i < answers.length; i++) {
            if (quiz.actions && quiz.actions.clearAnswer) quiz.actions.clearAnswer(answers[i].blockRef);
          }
        } catch(ex) {}
        window.location.reload();
      });
    }
  }

  function addToCart() {
    var btn = document.getElementById("db-checkout-btn");
    if (btn) { btn.textContent = "Adding to cart..."; btn.disabled = true; }
    var items = getSelectedProducts().map(function(key) {
      var months = state.tiers[key] || 3;
      return { id: PRODUCTS[key].variantId, quantity: months };
    });
    console.log("[DIMA Bundle] Adding items:", JSON.stringify(items));
    fetch("/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: "same-origin" })
      .then(function(res) {
        if (!res.ok) { throw new Error("Clear cart failed: " + res.status); }
        return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: "same-origin", body: JSON.stringify({ items: items }) });
      })
      .then(function(res) {
        if (!res.ok) { return res.text().then(function(t) { throw new Error("Add to cart failed (" + res.status + "): " + t); }); }
        return res.json();
      })
      .then(function(data) {
        console.log("[DIMA Bundle] Cart response:", JSON.stringify(data));
        if (!data || !data.items || data.items.length === 0) {
          throw new Error("Cart is empty after add — variant IDs may be invalid");
        }
        window.location.href = "/checkout";
      })
      .catch(function(err) {
        console.error("[DIMA Bundle] Cart error:", err);
        if (btn) { btn.textContent = "Something went wrong — try again"; btn.disabled = false; }
      });
  }

  // Capture-phase listener: intercepts checkout click BEFORE any other handler
  // This ensures our addToCart runs even if old inline script overwrites the button
  document.addEventListener("click", function(e) {
    var el = e.target;
    while (el && el !== document) {
      if (el.id === "db-checkout-btn") {
        e.preventDefault();
        e.stopImmediatePropagation();
        addToCart();
        return;
      }
      el = el.parentNode;
    }
  }, true);

  var initialized = false;

  function init() {
    if (initialized) return;
    initialized = true;
    var qr = document.querySelector("[id*='revenuehunt'] quiz-renderer");
    if (qr) {
      qr.classList.remove("dima-show-quiz");
      qr.style.display = "none";
    }
    quizData = getQuizData();
    var available = getAvailableProducts();
    state = { selected: {}, tiers: {} };
    available.forEach(function(p) {
      state.tiers[p] = 3;
      if (quizData.rec === "both") { state.selected[p] = (p === "finasteride"); }
      else { state.selected[p] = (p === quizData.rec); }
    });
    render();
    var root = document.getElementById("dima-bundle-root");
    if (root) root.scrollIntoView({ behavior: "smooth", block: "start" });

    // Watch for old inline script overwriting our render
    if (root && typeof MutationObserver !== "undefined") {
      new MutationObserver(function() {
        if (!document.getElementById("dima-v2-mark") && initialized) {
          syncStateFromDOM();
          render();
        }
      }).observe(root, { childList: true });
    }
  }

  function syncStateFromDOM() {
    var root = document.getElementById("dima-bundle-root");
    if (!root) return;
    var toggles = root.querySelectorAll("[data-toggle]");
    for (var i = 0; i < toggles.length; i++) {
      var key = toggles[i].getAttribute("data-toggle");
      if (key && PRODUCTS[key]) {
        state.selected[key] = toggles[i].classList.contains("active");
      }
    }
    var tiers = root.querySelectorAll(".db-tier-card.selected, [data-months].selected");
    for (var j = 0; j < tiers.length; j++) {
      var pk = tiers[j].getAttribute("data-product");
      var mo = parseInt(tiers[j].getAttribute("data-months"));
      if (pk && mo) { state.tiers[pk] = mo; }
    }
  }

  function showQuizRenderer() {
    var qr = document.querySelector("[id*='revenuehunt'] quiz-renderer");
    if (qr) {
      qr.style.display = "";
      qr.classList.add("dima-show-quiz");
    }
  }

  function isResultsMode() {
    try {
      if (typeof quiz !== "undefined" && (quiz.mode === "results" || quiz.mode === "result")) return true;
    } catch(e) {}
    return false;
  }

  function tryInit() {
    if (isResultsMode()) { init(); return; }
    var quizShown = false;
    var pollCount = 0;
    var pollInterval = setInterval(function() {
      pollCount++;
      if (initialized || pollCount > 600) { clearInterval(pollInterval); return; }
      if (isResultsMode()) { clearInterval(pollInterval); init(); return; }
      if (!quizShown) {
        try {
          if (typeof quiz !== "undefined") { quizShown = true; showQuizRenderer(); }
        } catch(e) {}
      }
    }, 500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInit);
  } else {
    tryInit();
  }
})();
